var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2275 19.9956C28.5829 21.5945 26.3435 22.5 24 22.5C21.6565 22.5 19.4171 21.5945 17.7725 19.9956C16.1293 18.3981 15.2143 16.2405 15.2143 14C15.2143 11.7595 16.1293 9.60195 17.7725 8.00442C19.4171 6.4055 21.6565 5.5 24 5.5C26.3435 5.5 28.5829 6.4055 30.2275 8.00442C31.8706 9.60195 32.7857 11.7595 32.7857 14C32.7857 16.2405 31.8706 18.3981 30.2275 19.9956ZM7.5 41.6797C7.5 34.8524 13.2008 29.25 20.3277 29.25H27.6723C34.7992 29.25 40.5 34.8524 40.5 41.6797C40.5 42.093 40.1429 42.5 39.6134 42.5H8.38661C7.85706 42.5 7.5 42.093 7.5 41.6797Z",
    stroke: "#202117",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalProfile);
export default __webpack_public_path__ + "static/media/modal-profile.c529ba5b9c9e48404af533b2cdd30295.svg";
export { ForwardRef as ReactComponent };